<template>
  <div>
    <b-table-simple hover small caption-top responsive>
      <b-thead>
        <b-tr>
          <b-th v-for="field in fieldValues" :key="field.key">
            {{ field.label }}
          </b-th>
        </b-tr> </b-thead
      ><b-tbody>
        <template v-for="row in activetableRowsList">
          <!-- {{ row }} -->
          <b-tr :key="row.field.sequenceNumber">
            <b-td class="td-id">
              {{ row.field.sequenceNumber }}
            </b-td>
            <b-td class="td-input">
              <b-form-input class="valor" type="text" v-model="row.field.value">
              </b-form-input>
            </b-td>
            <b-td class="td-acoes">
              <workflow-table-resequence
                class="d-inline"
                :item="row.field"
                :items="values"
                :display-name="row.field.value"
                :title="$t('checklist.form.fieldResequence')"
                v-b-tooltip.hover
              ></workflow-table-resequence>
              <b-button
                size="sm"
                class="ml-1"
                :title="$t('checklist.form.fieldOptionDelete')"
                v-b-tooltip.hover
                @click="deleteValue(row.field)"
              >
                X
              </b-button>
              <b-button
                size="sm"
                class="ml-1"
                :title="$t('checklist.form.fieldOptionClone')"
                v-b-tooltip.hover
                @click="cloneValue(row.field, values)"
              >
                <i class="tim-icons icon-single-copy-04"></i>
              </b-button>
              <b-button
                v-if="allowAddFields == true"
                size="sm"
                class="ml-1"
                v-b-tooltip.hover
                @click="setAdditionalField(row)"
              >
                <i
                  v-if="row.detailsShowing"
                  class="tim-icons icon-simple-delete"
                ></i>
                <i v-else class="tim-icons icon-simple-add"></i>
              </b-button>
            </b-td>
          </b-tr>

          <b-tr class="b-table-details" v-if="row.detailsShowing">
            <b-td :colspan="fieldValues.length">
              <h4>
                {{ $t("checklist.form.fieldOptionAdditionalAdd") }}:
                {{ row.field.valor }}
              </h4>
              <workflow-field
                ref="tableFields"
                :fields="row.field.additionalField"
                :stage="stage"
              >
              </workflow-field>
            </b-td>
          </b-tr>
        </template> </b-tbody
    ></b-table-simple>
    <b-button :disabled="disable" size="sm" @click="addValues()">
      {{ $t("checklist.form.fieldOptionAdd") }}
    </b-button>
    <!-- {{ values }} -->
    <!-- <div>{{ tableRows }}</div> -->
    <!-- <pre class="language-json"><code>tableRows{{ tableRows  }}</code></pre> -->

  </div>
</template>

<script>
import WorkflowCloneField from "./WorkflowCloneField";
export default {
  name: "WorkflowTableValue",
  mixins: [WorkflowCloneField],
  props: {
    values: Array,
    allowAddFields: Boolean,
    // optionsProfiles: Array,
    // profiles: Array,
    // userMaster: Boolean,
    fieldType: Number,
    stage: Boolean,
  },
  components: {
    WorkflowTableResequence: () => import("./WorkflowTableResequence.vue"),
    WorkflowField: () => import("./WorkflowField.vue")
  },
  data() {
    return {
      fieldValues: [
        {
          label: "Id",
          key: "sequenceNumber",
          sortable: false,
        },
        {
          label: "Valor",
          key: "value",
          sortable: false,
        },
        {
          key: "actions",
          label: "",
          sortable: false,
        },
      ],
      importValues: "",
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsAnomaly: [
        { value: 1, text: "Não" },
        { value: 2, text: "Sim" },
        // { value: 3, text: 'Por Script' },
      ],
      disable: false,
      tableCount: 0,
      tableRows: [],
    };
  },
  mounted: function () {
    this.loadTableRows();
  },
  computed: {
    activetableRowsList() {
      if (!this.tableRows) return [];
      if (this.tableRows == null) return [];
      let itemsAtivos = [];
      for (let campo of this.tableRows.sort(
        (c1, c2) => c1.field.sequenceNumber - c2.field.sequenceNumber
      )) {
        if (campo.field.active) {
          itemsAtivos.push(campo);
        }
      }
      return itemsAtivos;
    },
  },
  methods: {
    addTableRow(value) {
      this.tableRows.push({
        configShowing: false,
        detailsShowing: false,
        field: value,
      });
    },
    addValues() {
      if (this.fieldType == 13) {
        this.tableCount++;
        // console.log(this.tableCount )
        if (this.tableCount == 3) this.disable = true;
      }
      let value = {
        active: true,
        sequenceNumber: this.getNextSequenceNumber(this.values),
        value: "",
        hasAdditionalField: false,
        additionalField: [],
      };
      console.log(value);
      this.values.push(value);
      this.addTableRow(value);
      this.$forceUpdate();
    },
    loadTableRows() {
      this.tableRows = [];
      if (this.values) {
        if (this.values.length > 0) {
          this.values.forEach((value) => {
            this.addTableRow(value);
          });
        }
      }
      this.$forceUpdate();
    },
    deleteValue(row) {
      // console.log(row)
      if (!row.id || row.id == 0) {
        let indice = this.values.indexOf(row);

        if (indice >= 0) {
          this.values.splice(indice, 1);
        }
      } else {
        row.active = false;
      }
      if (this.fieldType == 13) {
        this.tableCount--;
        if (this.tableCount == 3) this.disable = true;
        else this.disable = false;
      }
      // reordenação da sequenciaExibicao apos remover o campo
      let orderedItems = this.activetableRowsList;
      for (let i = 0; i < orderedItems.length; i++) {
        orderedItems[i].sequenceNumber = i + 1;
      }
    },
    cloneValue(valorBase, listaValores) {
      this.copyValue(valorBase, listaValores);
      this.$forceUpdate();
    },
    displayConfig(fieldValueRow) {
      if (fieldValueRow) {
        fieldValueRow.configShowing = !fieldValueRow.configShowing;
      }
      // this._computedWatchers.activetableRowsList.run();
      this.$forceUpdate();
    },
    setAdditionalField(fieldValueRow) {
      console.log(fieldValueRow)
      if (fieldValueRow) {
        fieldValueRow.detailsShowing = !fieldValueRow.detailsShowing;
        fieldValueRow.field.hasAdditionalField =
          !fieldValueRow.field.hasAdditionalField;
      }
      //   this._computedWatchers.activetableRowsList.run();
      this.$forceUpdate();
    },
  },
  watch: {
    values() {
      this.loadTableRows();
    },
  },
};
</script>
